import React from 'react';
import {connect} from 'react-redux'
import Paper from 'material-ui/Paper';

import {formValueSelector, isDirty} from 'redux-form'

import {Link} from 'react-router-dom'

import PageBase from '../../components/PageBase';
import YosanForm from './YosanForm'
import YosanHistoryForm from './YosanHistoryForm'

import gStyles from '../../styles'

import * as actions from '../../actions'

import $ from 'jquery'
import _ from 'lodash'

class YosanHistoryPage extends React.Component {

    componentDidMount() {
        const {
            match
        } = this.props

        this.props.init(match.params.id, match.params.yearMonth)

        // this.unblock = this.props.history.block((location, action) => {
        //     if (this.props.dirty) {
        //         return '入力した情報は保存されません。よろしいですか？'
        //     }
        // })

    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        const {
            history,
            transition
        } = this.props

        if (transition) {
            history.push("/yosanHistoryList")
        }
    }

    render() {

        const {
            auth,
            form,
            selectData,
            kenmeiNames,
            materialCosts,
            outsourcingCosts,
            roumuCosts,
            expenseCosts,
            orderAmmounts,
            orderAmmount,
            orderAmmountBudget,
            claimAmmounts,
            claimAmmount,
            kenmeiCode,
            match,
            handleFormRegistClick,
            handleFormDeleteClick,
            handleKenmeiChange,
            handleFormStatusClick,
            handleCostClick,
            costOpens,

            materialCostHistorys,
            roumuCostHistorys,
            outsourcingCostHistorys,
            expenseCostHistorys

        } = this.props

        return (
            <PageBase title="実行予算">
                <Paper style={gStyles.pageContents}>
                    <YosanForm
                        isHistory={true}
                        auth={auth}
                        status={form.status}
                        kenmeiData={selectData.kenmei}
                        costData={selectData.cost}
                        userData={selectData.user}
                        initialValues={form}
                        materialCosts={materialCosts}
                        outsourcingCosts={outsourcingCosts}
                        roumuCosts={roumuCosts}
                        expenseCosts={expenseCosts}
                        orderAmmounts={orderAmmounts}
                        orderAmmount={orderAmmount}
                        orderAmmountBudget={orderAmmountBudget}
                        claimAmmounts={claimAmmounts}
                        claimAmmount={claimAmmount}
                        kenmeiNames={kenmeiNames}
                        onKenmeiChange={handleKenmeiChange}
                        onFormRegistClick={handleFormRegistClick}
                        onFormDeleteClick={handleFormDeleteClick}
                        onFormStatusClick={handleFormStatusClick}

                        costOpens={costOpens}
                        onCostClick={handleCostClick}

                        materialCostHistorys={materialCostHistorys}
                        roumuCostHistorys={roumuCostHistorys}
                        outsourcingCostHistorys={outsourcingCostHistorys}
                        expenseCostHistorys={expenseCostHistorys}

                    />
                </Paper>
            </PageBase>
        );

    }

}
//
// const selector = formValueSelector('yosanHistoryForm')
// const mapStateToProps = (state) => {
//
//     const materialCosts = selector(state, 'materialCosts')
//     const outsourcingCosts = selector(state, 'outsourcingCosts')
//     const roumuCosts = selector(state, 'roumuCosts')
//     const expenseCosts = selector(state, 'expenseCosts')
//     const orderAmmounts = selector(state, 'orderAmmounts')
//     const orderAmmount = selector(state, 'orderAmmount')
//     const orderAmmountBudget = selector(state, 'orderAmmountBudget')
//
//     const claimAmmounts = selector(state, 'claimAmmounts')
//     const claimAmmount = selector(state, 'claimAmmount')
//
//     return {
//         auth: state.auth,
//         transition: state.yosan.transition,
//         form: state.yosan.form,
//         selectData: state.yosan.selectData,
//         kenmeiNames: state.yosan.kenmeiNames,
//         materialCosts: materialCosts,
//         outsourcingCosts: outsourcingCosts,
//         roumuCosts: roumuCosts,
//         expenseCosts: expenseCosts,
//         orderAmmounts: orderAmmounts,
//         orderAmmount: orderAmmount,
//         orderAmmountBudget: orderAmmountBudget,
//         claimAmmounts: claimAmmounts,
//         claimAmmount: claimAmmount,
//         costOpens: state.yosan.costOpens,
//         dirty: isDirty('yosanHistoryForm')(state),
//     }
// }



const selector = formValueSelector('yosanForm')
const mapStateToProps = (state) => {

    const orderAmmounts = selector(state, 'orderAmmounts')
    const orderAmmount = selector(state, 'orderAmmount')
    const orderAmmountBudget = selector(state, 'orderAmmountBudget')

    const claimAmmounts = selector(state, 'claimAmmounts')
    const claimAmmount = selector(state, 'claimAmmount')

    const materialCosts = selector(state, 'materialCosts')
    const materialCostHistorys = selector(state, 'materialCostHistorys')

    const roumuCosts = selector(state, 'roumuCosts')
    const roumuCostHistorys = selector(state, 'roumuCostHistorys')

    const outsourcingCosts = selector(state, 'outsourcingCosts')
    const outsourcingCostHistorys = selector(state, 'outsourcingCostHistorys')

    const expenseCosts = selector(state, 'expenseCosts')
    const expenseCostHistorys = selector(state, 'expenseCostHistorys')

    return {
        auth: state.auth,
        transition: state.yosan.transition,
        form: state.yosan.form,
        selectData: state.yosan.selectData,
        kenmeiNames: state.yosan.kenmeiNames,
        materialCosts: materialCosts,
        outsourcingCosts: outsourcingCosts,
        roumuCosts: roumuCosts,
        expenseCosts: expenseCosts,
        orderAmmounts: orderAmmounts,
        orderAmmount: orderAmmount,
        orderAmmountBudget: orderAmmountBudget,
        claimAmmounts: claimAmmounts,
        claimAmmount: claimAmmount,
        materialCostHistorys: materialCostHistorys,
        roumuCostHistorys: roumuCostHistorys,
        outsourcingCostHistorys: outsourcingCostHistorys,
        expenseCostHistorys: expenseCostHistorys,
        dirty: isDirty('yosanForm')(state),
    }
}


const mapStateToDispatch = (dispatch) => ({
    init: (id, yearMonth) => {
        dispatch(actions.systemYosanHistoryInit(id, yearMonth))
    },
    handleFormRegistClick: (id) => (values) => {
        dispatch(actions.userYosanFormRegist(id, values))
    },
    handleCostClick: (kind, month) => () => {
        dispatch(actions.userYosanHistoryCostOpens(kind, month))
    },
    handleFormDeleteClick: (id) => (values) => {
        if (window.confirm("実行予算を削除してもよろしいですか？")) {
            dispatch(actions.userYosanFormDelete(id, values))
        }
    },
    handleKenmeiChange: (kenmeiNames) => {
        dispatch(actions.reducerYosanSetKenmeiNames(kenmeiNames))
    },
    handleFormStatusClick: (id, statusChange) => (values) => {
        const form = {statusChange: statusChange}

        dispatch(actions.userYosanFormRegist(id, form))
    },
})

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(YosanHistoryPage)




// WEBPACK FOOTER //
// ./src/containers/yosan/YosanHistoryPage.js